import $ from 'jquery';
import Swiper from 'swiper';
import onDocumentReady from '../util/onDocumentReady';

const productSliders = {};

const createProductSlider = (key) => {
    if (productSliders[key] !== undefined) {
        return false;
    }
    productSliders[key] = new Swiper('.product-slider .swiper-container', {
        speed: 600,
        spaceBetween: 20,
        slidesPerView: 5,
        autoHeight: true,
        pagination: {
            el: `.product-slider[data-slider=${key}] .product-slider-control__pagination`,
            type: 'fraction',
        },
        navigation: {
            nextEl: '.product-slider-control__button--next',
            prevEl: '.product-slider-control__button--prev',
        },

        breakpoints: {
            767: {
                slidesPerView: 1,
            },
            1023: {
                slidesPerView: 3,
            },
            1439: {
                slidesPerView: 4,
            },
        },
    });
    return true;
};

onDocumentReady(() => {
    $('.product-slider').each(function () {
        const $this = $(this);
        createProductSlider($this.attr('data-slider'));
    });
});
